module.exports = __webpack_public_path__ + "img/water_tank_bottom.8479edbc.svg";